<template>
    <div>
        <div class="arrow-up"></div> 
        <v-card class="content">           
            <v-card-text>
                <template v-if="!$props.gettingInitialAlarmsList">
                    <div class="alarm-container mr-3" @click="goToAlarmsWithFilter('critical')">
                        <v-icon :color="colors.critical.new.background" x-large>mdi-bell</v-icon>
                        <span class="label" :style="{color: colors.critical.new.background}">critical</span>
                        <div class="number">
                            <span v-text="criticalListLength" :style="{color: colors.critical.new.foreground}" />
                        </div>
                    </div>

                    <div class="alarm-container mr-3" @click="goToAlarmsWithFilter('major')">
                        <v-icon :color="colors.major.new.background" x-large>mdi-bell</v-icon>
                        <span class="label" :style="{color: colors.major.new.background}">major</span>
                        <div class="number">
                            <span v-text="majorListLength" :style="{color: colors.major.new.foreground}" />
                        </div>
                    </div>

                    <div class="alarm-container mr-3" @click="goToAlarmsWithFilter('minor')">
                        <v-icon :color="colors.minor.new.background" x-large>mdi-bell</v-icon>
                        <span class="label" :style="{color: colors.minor.new.background}">minor</span>
                        <div class="number">
                            <span v-text="minorListLength" :style="{color: colors.minor.new.foreground}" />
                        </div>
                    </div>

                    <div class="alarm-container mr-3" @click="goToAlarmsWithFilter('observational')">
                        <v-icon :color="colors.observational.new.background" x-large>mdi-bell</v-icon>
                        <span class="label" :style="{color: colors.observational.new.background}">observe</span>
                        <div class="number">
                            <span v-text="observationalListLength" :style="{color: colors.observational.new.foreground}" />
                        </div>
                    </div>

                    <div class="alarm-container" @click="goToAlarmsWithFilter('telsasoft')">
                        <v-icon color="#FB8C00" :class="{'danger-blink': telsasoftUnackExist}" x-large>mdi-triangle</v-icon>
                        <span class="label" :class="{'danger-blink': telsasoftUnackExist}" style="color: #FB8C00;">telsasoft</span>
                        <div class="number mt-1">
                            <span v-text="telsasoftListLength" style="color: #000000;" />
                        </div>
                    </div>
                </template>
                <div class="getting-alarms" v-if="$props.gettingInitialAlarmsList">
                    <span>Getting Alarms...</span>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'AlarmCountSummary',
    props: ['gettingInitialAlarmsList'],
    data: () => ({
    }),

    computed: {
        colors: function() {
            return this.$store.state.batchConfig.webapp_settings.alarms.alarmColors;
        },

        criticalListLength: function() {
            return this.$store.state.alarmsList.filter(alarm => {
                return (alarm.alarm_severity.toLowerCase() == 'critical');
            }).length;
        },
        majorListLength: function() {
            return this.$store.state.alarmsList.filter(alarm => {
                return (alarm.alarm_severity.toLowerCase() == 'major');
            }).length;
        },
        minorListLength: function() {
            return this.$store.state.alarmsList.filter(alarm => {
                return (alarm.alarm_severity.toLowerCase() == 'minor');
            }).length;
        },
        observationalListLength: function() {
            return this.$store.state.alarmsList.filter(alarm => {
                return (alarm.alarm_severity.toLowerCase() == 'observational');
            }).length;
        },

        telsasoftListLength: function() {
            return this.$store.state.alarmsList.filter(alarm => {
                return (alarm.alarm_office.toLowerCase().includes('telsasoft'));
            }).length;
        },

        telsasoftUnackExist: function() {
            return this.$store.state.alarmsList.some(alarm => {
                return (alarm.alarm_office.toLowerCase().includes('telsasoft') && !alarm.alarm_ack_time);
            });
        },
    },

    methods: {
        goToAlarmsWithFilter: function(severity) {
            this.$store.commit('setAlarmTrayFilter', severity);
            if(this.$route.name != 'alarms') {
                this.$router.push('alarms');
            }
        }
    },

    mounted() {
    }


    };
</script>

<style scoped>

    .content {
        width: 480px;
        height: 110px;
        position: relative;
    }

    .arrow-up {
        width: 0; 
        height: 0; 
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        position: relative;
        left: calc(50% - (10px / 2));
        top: 0px;
        border-bottom: 10px solid #424242;
        z-index: 10;
    }

    .alarm-container {
        display: inline-block;
        position: relative;
        width: 80px;
        text-align: center;
        cursor: pointer;
    }

    .alarm-container i {
    }

    .alarm-container .label {
        display: block;
        text-transform: uppercase;
    }

    .alarm-container .number {
        position: absolute;
        top: 9px;
        width: 100%;
        text-align: center;
        font-weight: bold;
    }
    

    @media(max-width: 600px) {
        .arrow-up {
            left: calc((100% / 2) - 38px);
        }

        .content {
            width: 100%;
            max-width: 100%;
            height: 75px;
        }

        .alarm-container {
            width: calc((100% / 5) - 10px);
        }
        .alarm-container .label {
            font-size: 12px;
            display: none;
        }
    }

    .danger-blink {
        animation: dangerBlink 1s infinite;
    }
    @keyframes dangerBlink {
	    0% { color: #FB8C00;}
        50% { color: #ffffff;}
    }

    .getting-alarms {
        display: block;
        position: relative;
        width: 100%;
        text-align: center;
        font-size: 32px;
        padding-top: 20px;
    }

</style>
